import Layout from "../../../components/Layout/Layout";
import BreadCrumb from "../../../components/BreadCrumb/Breadcrumb";
// import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// import Button from "../../../components/Button/Button";
import { useEffect, useState } from "react";
import Tabs from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import useStyles from "../styles";
import SchoolOverview from "./SchoolOverview";
import SchoolMember from "../staffs/StaffMembers";
import SchoolStudent from "../student/SchoolStudent";
import SchoolPlan from "./SchoolPlans";
import SchoolClasses from "./SchoolClasses";
import SchoolSubject from "./SchoolSubject";
import StudentApplication from "./StudentApplication";
import Attendance from "../attendance/index";
import Examination from "./Examination";
// import LeaveMgt from "../leavemgt/LeaveMgt";
// import PerfEval from "./PerfomanceEval";
// import Inventory from "../inventory/Inventory";
import { useNavigate, useParams } from "react-router-dom";
import { httprequest } from "../../../data/api";
import { ToastContainer, toast } from "react-toastify";
import AccessControl from "../accessControl/Index";
import LeaveMgt from "../leavemgt/LeaveMgt";
import Event from "../events/AdminEvents";
import Integration from "../integration/index";
import AdminTimeTable from "../timetable/AdminTimeTable";
import AdminNoticeBoard from "../noticeboard/AdminNoticeBoard";
import Enrolement from "../Enrolments/index";
import AccessCodes from "../accessControl/AccessCodes";
import GradingSystem from "../examination/component/GradingSystem";
import Assignment from "../assignment/Assignment";
import AdminLessonNote from "../lessonnote/AdminLessonNote";
import Button from "../../../components/Button/Button";
import { Icon } from "@iconify/react";
import Modal from "../../../components/Modal";
import InputGroup from "../../../components/FormComponent/InputGroup";

const SCHOOL_ENDPOINT = "/admin/v1/school";
const DELETE_SCHOOL = "/admin/v1/delete/school";

const AboutSchool = () => {
  const { id } = useParams();
  const classes = useStyles();
  const [data, setData] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);
  const [irreversibleModal, setIrreversibleModal] = useState(false);
  const [confirmationInput, setConfirmationInput] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const navigate = useNavigate();
  const [value, setValue] = useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    httprequest.get(`${SCHOOL_ENDPOINT}/${id}`).then((res) => {
      // eslint-disable-next-line no-console
      console.log(res?.data?.data?.school_name);
      setData(res?.data);
    }).catch((err) => {
      toast.error(err?.res);
      // eslint-disable-next-line no-console
      console.log(err);
    });
  }, []);

  const handleDeleteClick = () => {
    setConfirmModal(true);
  };

  const handleConfirmDelete = () => {
    if (confirmationInput === data?.data?.school_name) {
      setConfirmModal(false);
      setIrreversibleModal(true);
    } else {
      toast.error("School name does not match");
    }
  };

  const handleFinalDelete = () => {
    setIsDeleting(true);
    httprequest.delete(DELETE_SCHOOL, {
      data: { school_ids: [id] }
    })
      .then(() => {
        toast.success("School successfully deleted");
        setIrreversibleModal(false);
        setTimeout(() => {
          navigate("/schools");
        }, 1500);
      })
      .catch(() => {
        toast.error("Failed to delete school");
      })
      .finally(() => {
        setIsDeleting(false);
      });
  };

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/schools"
                link_one_name="Schools"
                active={`${data?.data?.school_name}`}
                description={`See the staff in ${data?.data?.school_name}.`}
              />
            </div>
            <Button
              variant="danger"
              buttonSize="fluid"
              color="btndefault"
              onClick={handleDeleteClick}
              buttonName={<div className="flex align-items-center gap-5"><span><Icon icon="ic:baseline-delete" width="24" height="24" /></span>Delete School</div>}
            />
          </div>
          <div className={classes.pageContent}>
            <TabContext value={value}>
              <div className="tablist-container no-margin-container horizontal-overflow">
                <Tabs indicatorColor="none" className="overide-tablist" onChange={handleChange} aria-label="">
                  <Tab style={{ fontSize: "12px" }} label="School Overview" value="1" />
                  <Tab style={{ fontSize: "12px" }} label="Staff Members" value="2" />
                  <Tab style={{ fontSize: "12px" }} label="Students" value="3" />
                  <Tab style={{ fontSize: "12px" }} label="School Plans" value="4" />
                  <Tab style={{ fontSize: "12px" }} label="Classes" value="5" />
                  <Tab style={{ fontSize: "12px" }} label="Subjects" value="6" />
                  <Tab style={{ fontSize: "12px" }} label="Student Application" value="7" />
                  <Tab style={{ fontSize: "12px" }} label="Enrolment" value="8" />
                  <Tab style={{ fontSize: "12px" }} label="Examinations" value="9" />
                  <Tab style={{ fontSize: "12px" }} label="Attendance" value="10" />
                  <Tab style={{ fontSize: "12px" }} label="Access Control" value="11" />
                  <Tab style={{ fontSize: "12px" }} label="Access Codes" value="12" />
                  <Tab style={{ fontSize: "12px" }} label="Event" value="13" />
                  <Tab style={{ fontSize: "12px" }} label="Integration" value="14" />
                  <Tab style={{ fontSize: "12px" }} label="Timetable" value="15" />
                  <Tab style={{ fontSize: "12px" }} label="Notice Board" value="16" />
                  <Tab style={{ fontSize: "12px" }} label="Leave Management" value="17" />
                  <Tab style={{ fontSize: "12px" }} label="Grading System" value="18" />
                  <Tab style={{ fontSize: "12px" }} label="Assignment" value="19" />
                  <Tab style={{ fontSize: "12px" }} label="Lesson Note" value="20" />
                </Tabs>
              </div>
              <TabPanel value="1" className="tabpanel-overide">
                <SchoolOverview />
              </TabPanel>
              <TabPanel value="2" className="tabpanel-overide"><SchoolMember /></TabPanel>
              <TabPanel value="3" className="tabpanel-overide"><SchoolStudent /></TabPanel>
              <TabPanel value="4" className="tabpanel-overide"><SchoolPlan /></TabPanel>
              <TabPanel value="5" className="tabpanel-overide"><SchoolClasses /></TabPanel>
              <TabPanel value="6" className="tabpanel-overide"><SchoolSubject /></TabPanel>
              <TabPanel value="7" className="tabpanel-overide"><StudentApplication /></TabPanel>
              <TabPanel value="8" className="tabpanel-overide"><Enrolement /></TabPanel>
              <TabPanel value="9" className="tabpanel-overide"><Examination user={data?.data?.user_id} /></TabPanel>
              <TabPanel value="10" className="tabpanel-overide"><Attendance /></TabPanel>
              <TabPanel value="11" className="tabpanel-overide"><AccessControl /></TabPanel>
              <TabPanel value="12" className="tabpanel-overide"><AccessCodes /></TabPanel>
              <TabPanel value="13" className="tabpanel-overide"><Event /></TabPanel>
              <TabPanel value="14" className="tabpanel-overide"><Integration /></TabPanel>
              <TabPanel value="15" className="tabpanel-overide"><AdminTimeTable /></TabPanel>
              <TabPanel value="16" className="tabpanel-overide"><AdminNoticeBoard user={data?.data?.user_id} /></TabPanel>
              <TabPanel value="17" className="tabpanel-overide"><LeaveMgt /></TabPanel>
              <TabPanel value="18" lassName="tabpanel-overide"><GradingSystem /></TabPanel>
              <TabPanel value="19" className="tabpanel-overide"><Assignment user={data?.data?.user_id} /></TabPanel>
              <TabPanel value="20" className="tabpanel-overide"><AdminLessonNote /></TabPanel>
            </TabContext>
          </div>
          {/* <TabPanel value="10" className="tabpanel-overide"><LeaveMgt /></TabPanel>
              <TabPanel value="11" className="tabpanel-overide"><PerfEval /></TabPanel>
              <TabPanel value="12" className="tabpanel-overide"><Inventory /></TabPanel> */}

          <Modal
            title={`Delete ${data?.data?.school_name}`}
            subtitle={"Please type the school name below to confirm deletion"}
            isopen={confirmModal}
            onClick={() => {
              setConfirmModal(false);
              setConfirmationInput("");
            }}
            modalContent={
              <div style={{ marginTop: "20px" }}>
                <InputGroup
                  label={`Type "${data?.data?.school_name}" to confirm`}
                  inputValue={confirmationInput}
                  onChange={(e) => setConfirmationInput(e.target.value)}
                  margin="normal"
                  inputName="confirmation"
                  inputType="text"
                />
              </div>
            }
            modalFooter={
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonName="Confirm"
                  buttonSize="full"
                  color="btndefault"
                  onClick={handleConfirmDelete}
                  disabled={confirmationInput !== data?.data?.school_name}
                />
                <Button
                  variant="primaryOutline"
                  buttonSize="full"
                  color="btnfontprimary"
                  buttonName="Cancel"
                  onClick={() => setConfirmModal(false)}
                />
              </div>
            }
          />

          {/* Second Irreversible Action Modal */}
          <Modal
            title="This Action Is Irreversible"
            subtitle={
              <div>
                You are about to permanently delete <span className="modal-name-highlight">{data?.data?.school_name}</span>.
                <br />
                All associated data will be lost and cannot be recovered.
              </div>
            }
            isopen={irreversibleModal}
            closeModal={() => setIrreversibleModal(false)}
            modalContent={
              <div style={{ color: "red", fontWeight: "bold", margin: "20px 0" }}>
                Are you absolutely sure you want to proceed?
              </div>
            }
            modalFooter={
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="danger"
                  buttonName="Delete Permanently"
                  buttonSize="full"
                  color="btndefault"
                  isLoading={isDeleting}
                  onClick={handleFinalDelete}
                />
                {/* <Button
                  variant="primaryoutline"
                  buttonSize="full"
                  color="btnprimary"
                  buttonName="Cancel"
                  onClick={() => setIrreversibleModal(false)}
                /> */}
              </div>
            }
          />
          <ToastContainer />
        </>
      }
    />
  );
};

export default AboutSchool;
